<route>
{
    "name": "offer-evolution-report-index",
    "meta": {
        "title": "Raport evolutie oferte",
        "requiresAuth": true,
        "permission": "guest",
        "fail": "/404"
    }
}
</route>
<template>
    <company-layout>
        <v-container fluid grid-list-xl>
            <v-row>
                <v-col>
                    <v-card class="my-2" :loading="loading" min-height="50vh">
                        <template slot="progress">
                            <v-overlay absolute class="d-flex flex-column text-center">
                                <div>
                                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                                        <span>In curs de incarcare...</span>
                                    </v-progress-circular>
                                </div>
                            </v-overlay>
                        </template>
                        <v-card-title>
                            Raport evolutie oferte
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-title>
                            <v-col md="2" sm="12">
                                <v-select
                                    v-model="filterByStatus"
                                    :items="(new $db.Offer).statuses"
                                    item-value="id"
                                    item-text="text"
                                    placeholder="Selecteaza status"
                                    multiple
                                />
                            </v-col>
                            <v-col md="2" sm="12">
                                <user-selector v-model="filterByUser"></user-selector>
                            </v-col>
                            <v-col md="4" sm="12">
                                <period-selector v-model="period" :checkbox="false" :button-class="['mt-3']"></period-selector>
                            </v-col>
                        </v-card-title>
                        <v-card-text v-if="!loading">
                            <v-row>
                                <v-col cols="12">
                                    <line-chart :chart-data="getChartData" :options="getChartOptions" :height="100"></line-chart>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card class="my-2" v-if="!loading && data.length">
                        <v-card-title>
                            Distributie per utilizator
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col offset="2" cols="4">
                                    <doughnut-chart :chart-data="getDistributionByCount"></doughnut-chart>
                                </v-col>
                                <v-col cols="4">
                                    <doughnut-chart :chart-data="getDistributionByAmount"></doughnut-chart>
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </company-layout>
</template>

<script>
    import CompanyLayout from "Layouts/Company.vue";
    import LineChart from "Components/reports/Line.vue";
    import DoughnutChart from "Components/reports/Doughnut.vue";
    import UserSelector from "Components/common/UserSelector";
    import PeriodSelector from "Components/common/PeriodSelector";

    export default {
        components: {
            CompanyLayout,
            LineChart,
            DoughnutChart,
            UserSelector,
            PeriodSelector
        },
        data () {
            return {
                loading: true,
                period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
                periodMenu: false,
                rawData: [],
                filterByUser: [],
                filterByStatus: []
            }
        },
        computed: {
            data() {
                return this.rawData.filter((item) => {
                    if(this.filterByUser.length < 1) return true
                    return this.filterByUser.indexOf(item.created_by) >= 0;
                }).filter((item) => {
                    if(this.filterByStatus.length < 1) return true
                    return this.filterByStatus.indexOf(item.status) >= 0;
                })
            },
            groups() {
                return this._.groupBy(this.data.map((order) => {
                    order.created_at_date = window.moment(order.created_at).format('YYYY-MM-DD')
                    return order
                }), 'created_at_date');
            },
            periodText () {
                return this.period.map(item => this.$options.filters.date(new Date(item))).join(' ~ ')
            },
            getChartData () {
                return {
                    datasets: [{
                        data: Object.values(this.groups).map((group) => this._.sumBy(group, 'amount_with_vat').toFixed(0)),
                        backgroundColor: this.colorScheme[0],
                        yAxisID: 'A',
                        label: 'Valoare comenzi'
                    },{
                        data: Object.values(this.groups).map((group) => group.length),
                        backgroundColor: this.colorScheme[1],
                        yAxisID: 'B',
                        label: 'Numar comenzi'
                    }],
                    labels: Object.keys(this.groups)
                }
            },
            getChartOptions() {
                let that = this
                return {
                    scales: {
                        yAxes: [{
                            id: 'A',
                            type: 'linear',
                            position: 'left',
                        }, {
                            id: 'B',
                            type: 'linear',
                            position: 'right'
                        }]
                    }
                }
            },
            getDistributionByCount(){
                const data = Object.values(this._.groupBy(this.data, 'created_by'))
                return {
                    datasets: [{
                        data: data.map(item => item.length),
                        backgroundColor: data.map((e, i) => this.colorScheme[i])
                    }],
                    labels: data.map(item => {
                        const employee = this.Static.employees.find(employee => employee.id === this._.get(item, '0.created_by'))
                        return this._.get(employee, 'name', 'Nedefinit')
                    })
                }
            },
            getDistributionByAmount(){
                const data = Object.values(this._.groupBy(this.data, 'created_by'))
                return {
                    datasets: [{
                        data: data.map(item => this._.sumBy(item, 'amount_with_vat').toFixed(0)),
                        backgroundColor: data.map((e, i) => this.colorScheme[i])
                    }],
                    labels: data.map(item => {
                        const employee = this.Static.employees.find(employee => employee.id === this._.get(item, '0.created_by'))
                        return this._.get(employee, 'name', 'Nedefinit')
                    })
                }
            },
        },
        watch: {
            period: {
                async handler(val) {
                    await this.initialize()
                }
            }
        },
        async mounted() {
            await this.fetchData()
        },
        methods: {
            async fetchData () {
                if(this.period.length !== 2) return
                this.loading = true

                await this.initialize()
            },
            async initialize() {
                if(this.period.length !== 2) return
                this.loading = true
                this.rawData = []
                var query = this.$db.Offer
                    .select('id', 'created_by', 'amount_with_vat', 'status', 'created_at')
                    .limit(5000);

                if(this.period instanceof Array && this.period.length === 2) {
                    query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
                }
                    await query.get()
                    .then(({data}) => {
                        this.rawData = data.map((order) => {
                            order.amount_with_vat = parseFloat(order.amount_with_vat)
                            return order
                        })
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        }
    };
</script>
